import alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'
import collapse from '@alpinejs/collapse'
import newsletterForm from './components/newsletter-form.js'

import './components/primary-menu'
import './components/header-cart'
import './components/slider'
import './components/add-to-cart'
import './components/direct-add-to-cart'
import './components/quantity-input'
import './components/product-category'
import './components/product-popup'
import './components/product'
import './components/cart'
import './components/checkout'
import './components/coupon-form'
import './components/search'

import.meta.glob(['../images/**', '../fonts/**'])

alpine.plugin(intersect)
alpine.plugin(persist)
alpine.plugin(collapse)

alpine.data('newsletterForm', newsletterForm)

Object.assign(window, { Alpine: alpine }).Alpine.start()
